import script from "./CountdownTimer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CountdownTimer.vue?vue&type=script&lang=ts&setup=true"

import "./CountdownTimer.vue?vue&type=style&index=0&id=83a589f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a589f0"]])

export default __exports__